<template>
  <div>
    <transition name="mobile-menu-overlay">
      <div v-if="isOpen" class="mobile-menu-overlay" @click="close"></div>
    </transition>
    <transition name="mobile-menu-slide">
      <div v-if="isOpen" class="mobile-menu-drawer">
        <div class="mobile-menu-header">
          <img src="/media/logos/logo2025expand.jpg" class="mobile-menu-logo" alt="DiaB" />
    
        </div>
        <div class="mobile-menu-body">
          <router-link
            :to="{ name: 'decision_ai_coach_list' }"
            class="mobile-menu-item mobile-menu-item--featured"
            @click.native="close"
          >
            <span class="mobile-menu-item__icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/lightning.svg" />
            </span>
            <span class="mobile-menu-item__text">Decision AI Coach</span>
            <span class="mobile-menu-item__badge">AI</span>
          </router-link>

          <button class="mobile-menu-logout" @click="onLogout">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
            Đăng xuất
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'MobileMenu',
  props: {
    value: { type: Boolean, default: false },
  },
  computed: {
    isOpen() {
      return this.value;
    },
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
    onLogout() {
      this.$mgr.signOut();
    },
  },
};
</script>

<style scoped>
.mobile-menu-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1040;
}
.mobile-menu-drawer {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 280px;
  max-width: 85vw;
  background: #fff;
  z-index: 1050;
  display: flex;
  flex-direction: column;
  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.12);
}
.mobile-menu-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 20px;
  background: transparent;
  border-bottom: 1px solid #e9ecef;
  min-height: 60px;
}
.mobile-menu-logo {
  width: 40%;
  height: auto;
  display: block;
}
.mobile-menu-title {
  color: #333;
  font-size: 16px;
  font-weight: 600;
}
.mobile-menu-close {
  background: none;
  border: none;
  padding: 2px;
  cursor: pointer;
  color: #888;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  min-width: unset;
  min-height: unset;
  transition: background 0.15s;
}
.mobile-menu-close .svg-icon {
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mobile-menu-close .svg-icon svg {
  width: 16px;
  height: 16px;
}
.mobile-menu-close:hover {
  background: #f0f0f0;
  color: #333;
}
.mobile-menu-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px 12px;
}
.mobile-menu-featured-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #aaa;
  padding: 0 8px 8px;
}
.mobile-menu-item--featured {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f0f9f5;
  border: 1px solid #5DCAA5;
  border-radius: 10px;
  padding: 14px 16px;
  color: #0F6E56;
  text-decoration: none;
  min-height: 54px;
  transition: background 0.15s, border-color 0.15s;
  -webkit-tap-highlight-color: transparent;
}
.mobile-menu-item--featured:hover,
.mobile-menu-item--featured.router-link-active {
  background: #d9f2ea;
  border-color: #1D9E75;
  color: #0a5040;
  text-decoration: none;
}
.mobile-menu-item__icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  opacity: 0.8;
}
.mobile-menu-item__text {
  font-size: 14px;
  font-weight: 500;
  flex: 1;
}
.mobile-menu-item__badge {
  background: #1D9E75;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 10px;
}
.mobile-menu-logout {
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px 16px;
  background: #fff5f5;
  border: 1px solid #f5c6c6;
  border-radius: 10px;
  color: #c0392b;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: background 0.15s;
}
.mobile-menu-logout:hover {
  background: #fff5f5;
}
.mobile-menu-overlay-enter-active,
.mobile-menu-overlay-leave-active { transition: opacity 0.25s ease; }
.mobile-menu-overlay-enter,
.mobile-menu-overlay-leave-to { opacity: 0; }
.mobile-menu-slide-enter-active,
.mobile-menu-slide-leave-active { transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1); }
.mobile-menu-slide-enter,
.mobile-menu-slide-leave-to { transform: translateX(-100%); }
</style>
